import React from "react";
import { useAppSelector } from "../hooks/reduxHooks";
import AboutPage from "../taskpane/pages/AboutPage";
import AdminAreaPage from "../taskpane/pages/AdminAreaPage";
import ChatPage from "../taskpane/pages/AiPage";
import FavoritesPage from "../taskpane/pages/FavoritesPage";
import DownloadsPage from "../taskpane/pages/ProductsPage";
import UsefulLinksPage from "../taskpane/pages/UsefulLinksPage";
import { AppRoute, IAppPath } from "./AppRoutes";

const getPath = (data: IAppPath): IAppPath => data;

export const AppRoutes = {
  Products: getPath({
    Route: AppRoute.Products,
    Icon: "download",
    Label: "Downloads",
    Subtitle: "File Center",
    Description: "Access your purchased models"
  }),
  AdminArea: getPath({
    Route: AppRoute.AdminArea,
    Icon: "gear",
    Label: "Admin Area",
    Subtitle: "Skills, Models, Prices & Limits",
    Description: "Manage skills, models, prices and usage limits"
  }),
  AI: getPath({
    Route: AppRoute.AI,
    Label: "MFA AI",
    IconSrc: "ai_nav.png",
    Subtitle: "Underwriting Assistant",
    Description: "Get instant answers and use custom tools"
  }),
  UsefulLinks: getPath({
    Route: AppRoute.UsefulLinks,
    Icon: "browser-safari",
    Label: "Knowledge Base",
    Subtitle: "Useful Links",
    Description: "Collected wisdom at your fingertips"
  }),
  Favorites: getPath({
    Route: AppRoute.Favorites,
    Icon: "star-fill",
    Label: "Favorites",
    Subtitle: "Your Collection",
    Description: "Your favorite links from our collection"
  }),
  About: getPath({
    Route: AppRoute.About,
    Icon: "info",
    Label: "About",
    Subtitle: "",
    Description: "Learn more about MFA"
  })
}


export default function AppRouter() {
  const {
    currentRoute
  } = useAppSelector(state => state.navigation);

  switch (currentRoute) {
    case AppRoute.Products: return <DownloadsPage />;
    case AppRoute.AI: return <ChatPage />;
    case AppRoute.UsefulLinks: return <UsefulLinksPage />;
    case AppRoute.Favorites: return <FavoritesPage />;
    case AppRoute.About: return <AboutPage />;
    case AppRoute.AdminArea: return <AdminAreaPage />;
    // a route persisted by an older build may no longer exist; React 17 throws on an undefined render
    default: return <DownloadsPage />;
  }
}